import React from 'react';
import { AuthProvider } from './authContext';
import { ProfileProvider } from './userContext';
import { OrganizationProvider } from './OrganizationContext';
import { UploadProvider } from './uploadContext';

 const AppProvider = ({ children }) => {
  return (
    <AuthProvider>
      <ProfileProvider>
        <OrganizationProvider>
          <UploadProvider>
            {children}
          </UploadProvider>
        </OrganizationProvider>
      </ProfileProvider>
    </AuthProvider>
  );
};

export default AppProvider;
